import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { Box, CssBaseline } from '@mui/material';

import Sidebar from './components/navigation/Sidebar';
import keycloak from './keycloak';
import Blocks from './pages/Blocks';
import Dashboard from './pages/Dashboard';
import Deployments from './pages/Deployments';
import Executions from './pages/Executions';
import Flows from './pages/Flows';
import Logs from './pages/Logs';
import ManageUsers from './pages/ManageUsers';
import Models from './pages/Models';
import Monitoring from './pages/Monitoring';
import SecretsAndVariables from './pages/SecretsAndVariables';
import { axiosKeycloakInstance } from './services/api-client';
import AddBlock from './views/blocks/AddBlock';
import CurrentBlockRunnerLogs from './views/blocks/CurrentBlockRunnerLogs';
import AddFlow from './views/flows/AddFlow';
import ExecutionDetails from './views/executions/ExecutionDetails';
import AddModel from './views/models/AddModel';
import AddNamespace2 from './views/namespaces/Add';
import NamespacesAndDatasources from './pages/NamespacesAndDatasources';
import MLGraphViewer from './views/mlgraph/GraphViewer';

const App: React.FC = () => {
  const [showManageUsers, setShowManageUsers] = useState(false);

  useEffect(() => {
    const checkManageUsersPermission = async () => {
      try {
        const response = await await axiosKeycloakInstance.get(`users/${keycloak.subject}/role-mappings`)
        if (response.status === 200) {
          setShowManageUsers(true);
        }
      } catch (error) {
        console.error('Error fetching role mappings:', error);
        setShowManageUsers(false);
      }
    };

    checkManageUsersPermission();
  }, []);

  return (
    <Router>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Sidebar showManageUsers={showManageUsers} />

        <Box component="main" sx={{ flexGrow: 1, overflow: 'auto' }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />

            <Route path="/executions" element={<Executions />} />

            <Route path="/monitoring" element={<Monitoring />} />

            <Route path="/flows" element={<Flows />} />
            <Route path="/flows/add" element={<AddFlow />} />
            <Route path="/flows/:name/:id" element={<AddFlow />} />

            <Route path="/blocks" element={<Blocks />} />
            <Route path="/blocks/:block_type/:runner_id/:commit_id/logs" element={<CurrentBlockRunnerLogs />} />
            <Route path="/blocks/:type" element={<Blocks />} />
            <Route path="/blocks/:type/add" element={<AddBlock />} />
            <Route path="/blocks/:type/:name/:id" element={<AddBlock />} />

            <Route path="/models" element={<Models />} />
            <Route path="/models/add-model" element={<AddModel />} />

            <Route path="/namespaces-and-datasources" element={<NamespacesAndDatasources />} />
            <Route path="/namespaces-and-datasources/add" element={<AddNamespace2 />} />

            <Route path="/executions/:namespace" element={<Executions />} />
            <Route path="/executions/:ns/:wid/:id" element={<ExecutionDetails />} />

            <Route path="/logs" element={<Logs />} />

            <Route path="/deployments" element={<Deployments />} />

            {showManageUsers && <Route path="manage_users" element={<ManageUsers />} />}

            <Route path="secrets-and-variables" element={<SecretsAndVariables />} />

            <Route path="mlgraph" element={< MLGraphViewer />} />
          </Routes>
        </Box>
      </Box>
    </Router>
  );
};

export default App;
